export const ChartColorType = {
  Brand: "brand",
  Gold: "gold",
};
